import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { importAction, previewAction } from './creativeImportVideoActions';
import { TCreativeImportVideo } from './types';

const initialState: TCreativeImportVideo = {
  isComplete: false,
  errors: undefined,
  previews: undefined
};

const creativeImportVideoSlice = createSlice({
  name: 'creativeImportVideo',
  initialState: { ...initialState },
  reducers: {
    initializePreviews: (state) => {
      return {
        ...state,
        importVideos: undefined,
        previews: undefined,
        errors: undefined,
        isComplete: false
      };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(
      previewAction.fulfilled,
      (state, action: PayloadAction<any>) => {
        return {
          ...state,
          previews: action.payload,
          errors: undefined
        };
      }
    );
    builder.addCase(
      previewAction.rejected,
      (state, action: PayloadAction<any> & { error: any }) => {
        return {
          ...state,
          previews: undefined,
          errors: JSON.parse(action.error.message).data?.error
        };
      }
    );
    builder.addCase(
      importAction.rejected,
      (state, action: PayloadAction<any> & { error: any }) => {
        return {
          ...state,
          errors: JSON.parse(action.error.message).data?.message
        };
      }
    );
    builder.addCase(importAction.fulfilled, (state) => {
      return {
        ...state,
        isComplete: true
      };
    });
  }
});

export const { initializePreviews } = creativeImportVideoSlice.actions;

export default creativeImportVideoSlice.reducer;
